import colors from './colors';

const gameThemes = {
  'brawl stars': {
    primaryAccent: 'rgb(255, 165, 0)',
    btnBG: `rgb(255, 165, 0)`,
    fontColorOverLightBackground: 'white',
    fontColorOverDarkBackground: 'white',
    textShadow:
      '-1px 3px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000'
  },

  arknights: {
    thumbHeight: `135px`
  },

  'mobile legends bang bang': {
    primaryAccent: '#27A63D',
    btnBG: `linear-gradient(to bottom, #38c84f 0%, #148229 100%)`,
    thumbHeight: '120px',
    gameRadius: `2px`
  },

  'risk of rain 2': {
    primaryAccent: '#0F9AB1',
    thumbHeight: '120px'
  },

  'dota underlords': {
    primaryAccent: '#35834E',
    thumbHeight: '120px'
  },

  'clash of clans': {
    primaryAccent: '#C81B00',
  },
  smite: {
  },
  archero: {
  },
  'idle heroes': {
  },
  'heroes of the storm': {
    thumbHeight: `110px`,
  },
  'super smash bros ultimate': {
    thumbHeight: `120px`,
  },
  battlerite: {
    primaryAccent: '#EF7D24',
    thumbHeight: `110px`,
  },

  overwatch: {
    primaryAccent: '#cc7d00',
    thumbHeight: '130px',
  },

  pubg: {
    primaryAccent: '#FF9C00',
  },

  'yu gi oh duel links': {
    primaryAccent: '#0181CC',
  },

  'legends of runeterra': {
    primaryAccent: '#0181CC',
    thumbHeight: `150px`,
  },

  'arena of valor': {
    primaryAccent: '#AD8E58',
    btnBG: 'linear-gradient(to bottom, #dabf70 0%, #7b5820 100%)',
    thumbHeight: '130px',
  },

  warframe: {
    primaryAccent: '#D0011B',
    thumbHeight: '120px',
  },

  'tekken 7': {
    primaryAccent: '#D0011B',
  },

  'escape from tarkov': {
    primaryAccent: '#9e6c36',
    textTransform: 'none'
  },

  'teamfight tactics': {
    primaryAccent: '#9e6c36'
  },

  'dragonball fighterz': {
    primaryAccent: '#E3672A',
  },

  'afk arena': {
    primaryAccent: '#A07957',
  },

  'element arena': {
    primaryAccent: '#DB6531',
    thumbHeight: `120px`,
  },

  default: {
    primaryAccent: colors.primary,
    fontFamily: 'Helvetica'
  }
};

const gameTheme = gameName => {
  if (!gameName) {
    return gameThemes.default;
  }

  const gameNameLowerCase = gameName.toLowerCase();

  if (gameThemes[gameNameLowerCase]) {
    return gameThemes[gameNameLowerCase];
  }
  return gameThemes.default;
};

export default gameTheme;
